<template>
  <div>
    <b-modal
      id="modalInfo"
      v-model="isOpen"
      modal-class="modalInfo"
      :title="
        $t('label_evaluation_evidencesRequested_use_already_submitted_evidence')
      "
    >
      <span v-if="showWarning">{{
        $t("label_evaluation_evidences_warning_no_file")
      }}</span>
      <b-form-group
        id="file"
        :label="
          $t(
            'label_evaluation_evidencesRequested_evidencesRelated_lightbox_locate'
          )
        "
        label-for="file"
      >
        <b-btn
          class="inputField"
          :class="checkStatus"
          @click="openSelectFilesModal"
        >
          <b-row>
            <b-col style="text-align: left" cols="10">
              <b-row style="padding: 5px; margin-left: 5px">
                <b-col class="col-sm-auto selectedItem">
                  <span v-if="selectedEvidence">
                    {{ selectedEvidence.name }}</span
                  >
                </b-col>
              </b-row>
            </b-col>
            <b-col
              style="padding: 0px; margin: 0px"
              class="d-flex align-items-end"
              cols="2"
            >
              <div class="d-flex justify-content-right">
                <b-btn
                  style="background-color: #e4e4e4 !important; color: black"
                  @click="openSelectFilesModal"
                >
                  Browse
                </b-btn>
              </div>
            </b-col>
          </b-row>
        </b-btn>
      </b-form-group>
      <b-form-group
        id="descripcion"
        :label="
          $t(
            'label_evaluation_evidencesRequested_evidencesRelated_lightbox_description'
          )
        "
        label-for="descripcion"
      >
        <b-input-group>
          <b-textarea id="descripcion" v-model="description" />
        </b-input-group>
      </b-form-group>
      <div v-if="showErrors && !description" class="warning">
        {{ $t("label_evaluation_thisFieldMandatory_warning") }}
      </div>
      <div slot="modal-footer" class="w-100" style="text-align: center">
        <div class="d-flex justify-content-around">
          <b-row>
            <b-col>
              <b-btn @click="isOpen = false">
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_evidenceResubmission_warning_cancel"
                  )
                }}
              </b-btn>
            </b-col>
            <b-col>
              <b-btn variant="primary" :disabled="canSend" @click="loadFile()">
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_evidenceResubmission_warning_send"
                  )
                }}
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
    <selectEvidenceModal
      :show-modal.sync="showSelectEvidenceModal"
      :selected-evidence.sync="selectedEvidence"
      :evaluation-id="evaluationId"
      :evidences="evidences"
      :requirement="requirement"
    />
  </div>
</template>

<script>
import axios from "axios";
import SelectEvidenceModal from "../../../SelectEvidenceModal";

export default {
  name: "EvaluationOrganizationRelatedEvidencesModal",
  components: { SelectEvidenceModal },
  props: ["showModal", "requirement", "evaluationId"],
  data() {
    return {
      showWarning: false,
      description: null,
      showSelectEvidenceModal: false,
      selectedEvidence: null,
      evidences: [],
      showErrors: false,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.selectedEvidence = null;
        this.showErrors = false;
        this.description = null;
        this.$emit("update:showModal", newValue);
      },
    },
    checkStatus() {
      if (!this.selectedEvidence) {
        return "error";
      } else {
        return "success";
      }
    },
    canSend() {
      return this.selectedEvidence === null;
    },
  },
  methods: {
    loadFiles: async function () {
      await axios.get(`/Evidences/${this.evaluationId}`).then((response) => {
        this.evidences = response.data;
      });
    },

    openSelectFilesModal: async function () {
      await this.loadFiles();
      this.showSelectEvidenceModal = true;
    },

    loadFile: async function () {
      if (!this.description || !this.selectedEvidence) {
        this.showErrors = true;
      } else {
        await this.updateRelatedRequirements(this.selectedEvidence);
        this.$emit("newData", this.selectedEvidence);
        this.isOpen = false;
      }
    },
    updateRelatedRequirements: async function (evidence) {
      var reqIdArray = evidence.requirements || [];
      reqIdArray.push({
        requirementId: this.requirement.id.toString(),
        typeOfAssociation: "link",
        description: this.description,
      });
      const data = { requirements: reqIdArray };
      await axios.patch(`/Evidences/${evidence.id}`, data).then(() => {
        //  evidence.requirementId = this.requirement.id.toString()
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/variables";

.inputField {
  background-color: #ffffff !important;
  border-color: #4a4a4a;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  padding: 0px;
  &.error {
    border-color: #ff0000;
  }
  &.success {
    border-color: #28a745;
  }
}
.btn.inputField:hover {
  background-color: #eeeeee !important;
}
.btn.inputField:focus {
  background-color: #eeeeee !important;
  border-color: $primary-color;
}
button.btn.inputField:active {
  background-color: #eeeeee !important;
  border-color: $primary-color;
}
.selectedItem {
  background-color: #d1d1d1;
  border-radius: 5px;
  color: black;
  margin-right: 4px;
  margin-top: 4px;
}
.warning {
  color: #ff0000;
}
</style>
